import { CircleRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';

const defaultconstStatusColorMap = {
    Pending: 'warning',
    Failed: 'error',
    Success: 'success',
};

export const StatusField = ({
    row,
    field,
    colorMap = defaultconstStatusColorMap,
}) => {
    const { t } = useTranslation('controls');
    const value = get(row, field);
    const color = colorMap[value];

    return (
        <Stack direction="row" alignItems="center" gap={1}>
            <CircleRounded color={color} sx={{ height: 12, width: 12 }} />
            <Typography color={`${color}.main`} variant="labelLarge">
                {t('status.' + value)}
            </Typography>
        </Stack>
    );
};
